// Imports
import Vue from 'vue';
import autosize from 'autosize';
import axios from 'axios';
import api from './api.js';
import { default as dropzone } from 'dropzone';
import sortable from 'sortablejs';
import { default as XRegExp } from 'xregexp';
import PageErrors from './page-errors.js';
import { default as swal } from 'sweetalert2';
//import Echo from "laravel-echo";

// Import lodash
window._ = require('lodash');

// Load up jQuery and automatically send across our CSRF token
window.$ = window.jQuery = window.jquery = require('jquery');

// Setup the CSRF token
var csrf = $('meta[name="csrf-token"]').prop('content');
$.ajaxSetup({
    beforeSend: function (xhr) {
        xhr.setRequestHeader("X-Csrf-Token", csrf);
    }
});

// Load jquery-mousewheel
require('jquery-mousewheel');

// Load select2 into jquery
require('select2');
$.fn.select2.defaults.set('theme', 'bootstrap');
$.fn.select2.defaults.set('width', '');

// Load fancybox into jquery
require('fancybox')($);

// Load bootstrap into jquery
require('bootstrap');

// Load bootstrap-toggle into jQuery
require('bootstrap-toggle');

// Load bootstrap-tagsinput into jQuery
require('bootstrap-tagsinput');

// Load bootstrap-datepicker into jQuery
require('bootstrap-datepicker');

// Load our extensions
require('./extensions.js');

// Load our internal plugins into jquery
require('./plugins/jquery.ds-input-removable.js');

// Load Ckeditor
require('../plugins/ckeditor/ckeditor.js');
require('../plugins/ckeditor/adapters/jquery.js');

// Load bootstrap3-dialog
window.BootstrapDialog = require('bootstrap3-dialog');

// Load up Cropper
window.Cropper = require('cropperjs');

// Load sortable component
window.Sortable = sortable;

// Load up Vue
window.Vue = Vue;

// Use axios for HTTP requests
window.axios = axios;
axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-Csrf-Token': csrf
};

// Load our API
window.api = api;

// Load up our page errors
window.PageErrors = PageErrors;

// Load up sweet alert
window.swal = swal;

// Load up Dropzone
window.Dropzone = dropzone;

// Load up xregexp
window.XRegExp = XRegExp;

// Load up autosize
window.autosize = autosize;

// Echo exposes an expressive API for subscribing to channels and listening for events that are broadcast by Laravel.
// window.Echo = new Echo({
//     authEndpoint: $('meta[name="base"]').prop('content') + '/broadcasting/auth',
//     broadcaster: 'pusher',
//     key: '',
//     csrfToken: csrf
// });
